import emailjs from '@emailjs/browser'

export type MailPayload = {
  source: string
  parentName?: string
  email?: string
  phone?: string
  selectedProgram?: string
  childName?: string
  childAge?: string
  message?: string
}

// --- Direct configuration here ---
const EMAILJS_CONFIG = {
  SERVICE_ID: 'service_8icf8vs',       // ⚠️ Replace with your actual Service ID from EmailJS
  TEMPLATE_ID: 'template_u6hy5ai',     // ✅ Your template ID
  PUBLIC_KEY: 'DtrGxSe5BoUOlbT78',     // ⚠️ Replace with your actual Public Key from EmailJS
  TO_EMAIL: 'ruchitha.pellakuru@stembears.com', // Optional: if used in template
}

// --- Email sender function ---
export async function sendFormEmail(payload: MailPayload): Promise<void> {
  if (!EMAILJS_CONFIG.PUBLIC_KEY) {
    throw new Error('EmailJS PUBLIC_KEY is not set. Please update the PUBLIC_KEY value.')
  }

  if (!EMAILJS_CONFIG.SERVICE_ID || !EMAILJS_CONFIG.TEMPLATE_ID) {
    throw new Error('EmailJS SERVICE_ID or TEMPLATE_ID missing in the configuration.')
  }

  const templateParams = {
    source: payload.source,
    parent_name: payload.parentName ?? '',
    from_name: payload.parentName ?? '',
    email: payload.email ?? '',
    reply_to: payload.email ?? '',
    phone: payload.phone ?? '',
    selected_program: payload.selectedProgram ?? '',
    child_name: payload.childName ?? '',
    child_age: payload.childAge ?? '',
    message: payload.message ?? '',
    subject: `${payload.source}${payload.selectedProgram ? ' - ' + payload.selectedProgram : ''}`,
    to_email: EMAILJS_CONFIG.TO_EMAIL,
  }

  try {
    // Debug log for local testing
    if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
      console.log('[EmailJS] sending with params:', templateParams)
    }

    // EmailJS send call with a timeout to avoid hanging UI
    const sendPromise = emailjs.send(
      EMAILJS_CONFIG.SERVICE_ID,
      EMAILJS_CONFIG.TEMPLATE_ID,
      templateParams,
      EMAILJS_CONFIG.PUBLIC_KEY
    )

    const timeout = new Promise((_, reject) => setTimeout(() => reject(new Error('Email timeout')), 15000))

    await Promise.race([sendPromise, timeout])
    console.log('[EmailJS] Email sent successfully')
  } catch (err) {
    console.error('[EmailJS] send error', err)
    throw err
  }
}
